import { createRoutableExtension } from '@backstage/core-plugin-api';
import { catalogPlugin } from '@backstage/plugin-catalog';

export const AllowedSystemsCatalogIndexPage = catalogPlugin.provide(
  createRoutableExtension({
    name: 'AllowedSystemsCatalogIndexPage',
    component: () =>
      import('./AllowedSystemsCatalogPage').then(m => m.AllowedSystemsCatalogPage),
    mountPoint: catalogPlugin.routes.catalogIndex,
  }),
);
